{
  "SelectOptionEmpty": {
    "noResults": "No results"
  },
  "UnitField": {
    "cm_long": "Metric (cm)",
    "cm": "cm",
    "in_long": "Imperial (in)",
    "in": "in",
    "m_long": "Metric (m)",
    "m": "m",
    "ft_long": "Imperial (ft)",
    "ft": "ft",
    "placeholders": {
      "feet": "Feet",
      "inches": "Inches",
      "amount": "Amount",
      "unit": "Unit"
    }
  }
}
